import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiInspectorsList, apiInspectorsView } from 'Services/UserService'

export const getData = createAsyncThunk('user/inspectors/getData', async datas => {
    const { data } = await apiInspectorsList(datas)
    return data
})

export const getView = createAsyncThunk('user/inspectors/getView', async id => {
    if (!id) return viewData
    const { data } = await apiInspectorsView(id)
    data.image = ''
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    image: '',
    designation: '',
    department: '',
    mobile_no: '',
    type: '',
}

export const inspectorsSlice = createSlice({
    name: 'user/inspectors',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            type: '',
            status: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setType: (state, { payload }) => {
            state.table.page = 1
            state.table.type = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setType, setStatus } = inspectorsSlice.actions

export default inspectorsSlice.reducer
